// Real studio photos uploaded by the user
const A = "https://customer-assets.emergentagent.com/job_validation-hub-57/artifacts";
const B = "https://customer-assets-lxgj4vgw.emergentagent.net/job_validation-hub-57/artifacts";

// Masonry layout — each card sizes to the image's natural aspect ratio,
// so there is NO cropping and NO letterboxing.
// `featured: true` gets a slightly larger card in the flow.
export const PORTFOLIO = [
  {
    id: "lumino-lamp",
    title: "LUMINO — Smart Desk Lamp",
    category: "decor",
    tag: "Featured Product",
    desc: "Modular colour-block desk lamp with tilt-rotate head, weighted base and USB-C power.",
    img: `${B}/rpawniqr_image.png`,
    featured: true,
  },
  {
    id: "porsche-brake",
    title: "Porsche Brake LED Wall Display",
    category: "decor",
    tag: "Car Enthusiast",
    desc: "Backlit caliper-and-rotor decor piece, hand-finished gunmetal & Porsche crest.",
    img: `${A}/mtpxz3vr_2.jpg`,
  },
  {
    id: "camera-enclosure",
    title: "Pan-Tilt Camera Enclosure",
    category: "cad",
    tag: "Enclosure",
    desc: "Custom camera housing on a servo pan-tilt mount with hex base plate — CAD render.",
    img: `${B}/aonlp4k2_Screenshot%202025-09-23%20140629.png`,
  },
  {
    id: "d405-waterproof",
    title: "Waterproof Housing — RealSense D405",
    category: "cad",
    tag: "Waterproof",
    desc: "IP-sealed enclosure for the Intel RealSense Depth Camera D405 with GoPro-style mount.",
    img: `${B}/cs85mzsv_Screenshot%202026-07-27%20154248.png`,
  },
  {
    id: "smart-trolley",
    title: "Smart Surveillance Trolley",
    category: "stem",
    tag: "Smart Trolley",
    desc: "4-wheel off-road smart trolley with pan-tilt camera turret and 3-tier payload shelves.",
    img: `${B}/4zbgyubs_Screenshot%202025-04-16%20225213.png`,
  },
  {
    id: "dual-eye-sensor",
    title: "Dual-Eye Sensor Module",
    category: "stem",
    tag: "Robotics Vision",
    desc: "Compact printed sensor head with dual optical lenses, side-mount connectors and modular base.",
    img: `${B}/7v08w63q_ChatGPT%20Image%20Aug%2027%2C%202026%2C%2011_55_11%20AM.png`,
    featured: true,
  },
  {
    id: "spiral-lamp",
    title: "Spiral Ribbed Ambient Lamp",
    category: "decor",
    tag: "Lighting",
    desc: "Translucent vase-mode lamp with woven ribbed pattern over a fluted base.",
    img: `${A}/e2msg6id_6bee3c1078896ca902f188d60cbcc20e.jpg`,
  },
  {
    id: "hexapod",
    title: "Hexapod Spider Robot",
    category: "stem",
    tag: "Robotics Labs",
    desc: "Six-leg walking robot with sensor dome — fully 3D-printed servo brackets.",
    img: `${A}/shx90pnq_6d2b700baab57c791f514baddeae8e34.jpg`,
  },
  {
    id: "organic-pendant",
    title: "Organic Pendant Branch Light",
    category: "decor",
    tag: "Premium Decor",
    desc: "Sculptural sandstone-finish pendant with twin warm-diffuse globes.",
    img: `${A}/5tmgcixq_s.jpg`,
  },
  {
    id: "rover-render",
    title: "4×4 Rover — Assembly",
    category: "stem",
    tag: "Robotics",
    desc: "Off-road rover with pan-tilt turret, printed chassis and chunky rubber-tread wheels.",
    img: `${B}/o4ipforw_Screenshot%202025-04-16%20221027.png`,
  },
  {
    id: "gtr-frame",
    title: "Skyline GT-R Shadow Box",
    category: "cad",
    tag: "Custom Art",
    desc: "Multi-layered Skyline R34 shadow box with technical plate & 3D body.",
    img: `${A}/lgt2hap8_4.jpg`,
  },
  {
    id: "supra-organizer",
    title: "Supra Tail Key Organizer",
    category: "decor",
    tag: "Creative Gift",
    desc: "Wall-mounted Toyota Supra rear with hook rail — orange dual-tone PLA.",
    img: `${A}/z9vpdcg2_3.jpg`,
  },
  {
    id: "mecanum-rover",
    title: "Mecanum Rover with Robotic Arm",
    category: "stem",
    tag: "STEM Project",
    desc: "4-wheel mecanum mobile base with 4-DOF gripper arm for college robotics.",
    img: `${A}/7edijs0e_34fecb02c2184ac7483d5a1edbe7e82d.jpg`,
  },
  {
    id: "rover-cad",
    title: "4×4 Rover — CAD Blueprint",
    category: "cad",
    tag: "Blueprint",
    desc: "Full multi-view engineering drawing of the rover — front, side, top and iso.",
    img: `${B}/6vxi0fqp_Screenshot%202025-04-14%20233248.png`,
  },
  {
    id: "robotic-arm",
    title: "ESP32 Robotic Arm Build",
    category: "stem",
    tag: "Robotics",
    desc: "Multi-link manipulator with hobby servos & ESP32 controller — student kit.",
    img: `${A}/ipws9wof_bb27fd9f0ba948ce3b86e2dca3ecd36c.jpg`,
  },
  {
    id: "lego-blueprint",
    title: "Lego Figurine Blueprint",
    category: "cad",
    tag: "Blueprint",
    desc: "Hand-style CAD breakdown — front, top, side views with parts callouts.",
    img: `${A}/161tvv4t_1.jpg`,
  },
  {
    id: "gripper-cad",
    title: "Robotic Gripper Claw CAD",
    category: "cad",
    tag: "CAD Modeling",
    desc: "Parametric SolidWorks model with internal gearing and parallel jaws.",
    img: `${A}/r36cts0i_dbf2d53bbc01405ba17dec29060534e4.jpg`,
  },
];

// Auto-build filters from available categories
const META = {
  decor: "Decor & Lighting",
  stem: "College & STEM",
  cad: "CAD & Prints",
};
const present = Array.from(new Set(PORTFOLIO.map((p) => p.category)));
export const FILTERS = [
  { id: "all", label: "All Work" },
  ...present.map((id) => ({ id, label: META[id] || id })),
];
